import { createFileRoute } from "@tanstack/react-router";
import { useLanguage } from "@/i18n/LanguageProvider";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export const Route = createFileRoute("/faq")({
  head: () => ({
    meta: [
      { title: "FAQ — Code Cubs Academy" },
      {
        name: "description",
        content: "Answers to the most common parent questions about classes, ages, and trials.",
      },
    ],
  }),
  component: FaqPage,
});

function FaqPage() {
  const { t } = useLanguage();
  return (
    <div className="container mx-auto px-4 py-16 max-w-3xl">
      <h1 className="text-4xl lg:text-5xl font-extrabold text-center mb-10">{t.faq.title}</h1>
      <Accordion type="single" collapsible className="space-y-3">
        {t.faq.items.map((it, i) => (
          <AccordionItem
            key={i}
            value={`q${i}`}
            className="bg-card rounded-2xl border-0 shadow-soft px-5"
          >
            <AccordionTrigger className="text-start font-semibold">{it.q}</AccordionTrigger>
            <AccordionContent className="text-muted-foreground">{it.a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
}
